import * as THREE from 'three'
import gsap from 'gsap'
import '../style.css';

import Sizes from './Utils/Sizes.js'
import Time from './Utils/Time.js'
import Camera from './Camera.js'
import Renderer from './Renderer.js'
import World from './World/World.js'

let instance = null

export default class Experience {
    constructor(_canvas) {

        // Singleton    
        if (instance) {
            return instance
        }
        instance = this

        // Global access
        this.canvas = _canvas

        // Setup
        this.sizes = new Sizes()
        this.time = new Time()
        this.scene = new THREE.Scene()
        this.camera = new Camera()
        this.renderer = new Renderer()
        this.world = new World()
        this.sectionMeshes = [this.world.mesh1, this.world.mesh2, this.world.mesh3]

        // Camera Group
        this.cameraGroup = new THREE.Group()
        this.cameraGroup.add(this.camera.instance)
        this.scene.add(this.cameraGroup)

        // Cursor
        this.cursor = { x: 0, y: 0 }

        // Initialize scrollY
        this.scrollY = window.scrollY

        // THREE.Clock
        this.clock = new THREE.Clock()

        // Events
        this.sizes.on('resize', () => {
            this.resize()
        })

        this.time.on('tick', () => {
            this.update()
        })

        window.addEventListener('scroll', () => {
            this.scroll()
        })

        window.addEventListener('mousemove', (event) => {
            this.cursor.x = event.clientX / this.sizes.width - 0.5
            this.cursor.y = event.clientY / this.sizes.height - 0.5
        })

        // Initial update to render the scene
        this.update()
    }

    resize() {
        this.camera.resize()
        this.renderer.resize()
    }

    update() {
        const elapsedTime = this.time.elapsed
        const deltaTime = this.time.delta

        // Log delta time from Time.js
        // console.log('Time.js delta:', deltaTime)

        // Log delta time from THREE.Clock
        const clockDeltaTime = this.clock.getDelta()
        // console.log('THREE.Clock delta:', clockDeltaTime)

        // Animate camera
        this.camera.instance.position.y = - this.scrollY / this.sizes.height * this.world.objectsDistance

        const parallaxX = this.cursor.x * 0.5
        const parallaxY = - this.cursor.y * 0.5
        this.cameraGroup.position.x += (parallaxX - this.cameraGroup.position.x) * 5 * deltaTime
        this.cameraGroup.position.y += (parallaxY - this.cameraGroup.position.y) * 5 * deltaTime

        // Animate meshes
        for(const mesh of this.sectionMeshes) {
            mesh.rotation.x += deltaTime * 0.1
            mesh.rotation.y += deltaTime * 0.12
        }

        this.world.moon.rotate()
        this.world.update()
        this.renderer.update()
    }

    scroll() {
        this.scrollY = window.scrollY

        this.newSection = Math.round(this.scrollY / this.sizes.height)

        if(this.newSection != this.currentSection) {
            this.currentSection = this.newSection

            gsap.to(
                this.sectionMeshes[this.currentSection].rotation,
                {
                    duration: 1.5,
                    ease: 'power2.inOut',
                    x: '+=6',
                    y: '+=3',
                    z: '+=1.5'
                }
            )
        }
    }
}